import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    news: {
      items: [],
      count: '',
      pages: 0,
      entity: {},
    },
  },
  actions,
  mutations,
  getters,
};
